import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-16510fc6")

_pushScopeId("data-v-16510fc6")
const _hoisted_1 = { class: "statistics" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row mb-4" }
const _hoisted_4 = { class: "col-12 col-sm-6" }
const _hoisted_5 = { class: "col-12 col-sm-6" }
const _hoisted_6 = { class: "row content" }
const _hoisted_7 = { class: "col-12 col-sm-5" }
const _hoisted_8 = { class: "label label-ul" }
const _hoisted_9 = { class: "statistic-list" }
const _hoisted_10 = {
  key: 0,
  class: "col-12 col-sm-3"
}
const _hoisted_11 = { class: "label label-ul" }
const _hoisted_12 = { class: "label label-ul" }
const _hoisted_13 = { class: "row content" }
const _hoisted_14 = { class: "label label-ul" }
const _hoisted_15 = { class: "label label-margin" }
const _hoisted_16 = {
  key: 0,
  class: "col-3"
}
const _hoisted_17 = {
  key: 1,
  class: "col-3"
}
const _hoisted_18 = {
  key: 2,
  class: "col-4"
}
const _hoisted_19 = {
  key: 0,
  class: "row"
}
const _hoisted_20 = { class: "label label-margin" }
const _hoisted_21 = { class: "col-4 select-option" }
const _hoisted_22 = { class: "statistic-list" }
const _hoisted_23 = {
  key: 1,
  class: "row"
}
const _hoisted_24 = { class: "col-4 select-option" }
const _hoisted_25 = { class: "label label-margin" }
const _hoisted_26 = { class: "statistic-list" }
const _hoisted_27 = { class: "col-4" }
const _hoisted_28 = { class: "label label-margin" }
const _hoisted_29 = { class: "statistic-list" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col results mb-4" }
const _hoisted_32 = { class: "button-bulletin_name_div" }
const _hoisted_33 = { class: "row diagram" }
const _hoisted_34 = { class: "col" }
const _hoisted_35 = { class: "text diagram__title" }
const _hoisted_36 = { class: "diagram__tabs tabs mb-4" }
const _hoisted_37 = { class: "bulletin-name" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "bulletin-name" }
const _hoisted_40 = { class: "prediction" }
const _hoisted_41 = {
  key: 0,
  id: "prediction__border"
}
const _hoisted_42 = {
  key: 1,
  class: "diagram__content"
}
const _hoisted_43 = /*#__PURE__*/_createVNode("p", { class: "text diagram__text" }, null, -1)
const _hoisted_44 = { class: "chart" }
const _hoisted_45 = {
  key: 2,
  class: "diagram__content"
}
const _hoisted_46 = /*#__PURE__*/_createVNode("p", { class: "text diagram__text" }, null, -1)
const _hoisted_47 = { class: "container" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-7" }
const _hoisted_50 = { class: "col-5" }
const _hoisted_51 = { class: "download" }
const _hoisted_52 = { class: "button download__button button--primary" }
const _hoisted_53 = { class: "expand" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" Excel File ")
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" PDF File ")
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "col" }
const _hoisted_58 = { class: "diagram__content" }
const _hoisted_59 = {
  class: "table statistics__table",
  cellpadding: "4"
}
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" Вся таблица ")
const _hoisted_61 = {
  key: 0,
  id: "myModal",
  class: "modal"
}
const _hoisted_62 = { class: "modal-content modal-content__auth" }
const _hoisted_63 = { class: "modalcontent" }
const _hoisted_64 = { class: "modalcontent__h2" }
const _hoisted_65 = { class: "modalcontent__margin__auth" }
const _hoisted_66 = { class: "buttons" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache) {
  const _component_adaptive_main_top_line = _resolveComponent("adaptive-main-top-line")
  const _component_router_link = _resolveComponent("router-link")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_line_chart = _resolveComponent("line-chart")
  const _component_am_charts = _resolveComponent("am-charts")
  const _component_main_footer = _resolveComponent("main-footer")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_adaptive_main_top_line),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: "/statisticstwo",
              class: "button statistics__button statistics__button--active button--primary"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('main.dynamic')), 1 /* TEXT */)
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/statisticstwo/summary-table",
              class: "button statistics__button button--primary"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('main.summary')), 1 /* TEXT */)
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("label", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.$t('main.selectOrInput')) + " ", 1 /* TEXT */),
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "input",
                onKeyup: _cache[1] || (_cache[1] = (...args) => (_ctx.searchBulletinTimer(...args))),
                onFocus: _cache[2] || (_cache[2] = (...args) => (_ctx.searchBulletinTimer(...args))),
                onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.searchBulletinTimer(...args))),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (_ctx.data.search = $event)),
                placeholder: _ctx.inputPlaceBulletinName
              }, null, 40, ["placeholder"]), [
                [_vModelText, _ctx.data.search]
              ]),
              _createVNode(_component_svg_icon, { name: "triangle-down" })
            ]),
            _withDirectives(_createVNode("ul", _hoisted_9, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bulletins, (bulletin) => {
                return (_openBlock(), _createBlock("li", {
                  key: bulletin.id,
                  onClick: $event => (_ctx.clickBulletinById(bulletin.id, bulletin.name))
                }, _toDisplayString(bulletin.name), 9, ["onClick"]))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512), [
              [_vShow, _ctx.changeactive]
            ])
          ]),
          (!_ctx.oneLocalAndAttributeActive)
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                _createVNode("label", _hoisted_11, [
                  _createTextVNode(_toDisplayString(_ctx.$t('app.selectPeriod')) + " ", 1 /* TEXT */),
                  _createVNode("label", _hoisted_12, [
                    _withDirectives(_createVNode("select", {
                      id: "select-period",
                      onChange: _cache[5] || (_cache[5] = $event => (_ctx.showValuesByBulletin())),
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (_ctx.bulletinDate = $event)),
                      class: "custom-select"
                    }, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bulletinPeriod, (period, index) => {
                        return (_openBlock(), _createBlock("option", {
                          key: index,
                          value: index
                        }, _toDisplayString(period.from_date) + " | " + _toDisplayString(period.to_date), 9, ["value"]))
                      }), 128 /* KEYED_FRAGMENT */)),
                      _createVNode(_component_svg_icon, { name: "calendar" })
                    ], 544), [
                      [_vModelSelect, _ctx.bulletinDate]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("label", _hoisted_14, [
            _createVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('statistics.onerParameter')), 1)
          ]),
          (!_ctx.oneAttributeInLocation)
            ? (_openBlock(), _createBlock("div", _hoisted_16, [
                _createVNode("button", {
                  class: ["button-bulletin-change", {
              'button-bulletin-change-active':
                _ctx.oneValuesLocationAndAttributeIsActive
            }],
                  onClick: _cache[7] || (_cache[7] = $event => (_ctx.oneAttributes()))
                }, _toDisplayString(_ctx.$t('statistics.byRegion')), 3)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.oneLocationInAtributes)
            ? (_openBlock(), _createBlock("div", _hoisted_17, [
                _createVNode("button", {
                  class: "button-bulletin-change",
                  onClick: _cache[8] || (_cache[8] = $event => (_ctx.oneLocations()))
                }, _toDisplayString(_ctx.$t('statistics.ByIndicators')), 1)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.oneValuesLocationAndAttributeIsActive)
            ? (_openBlock(), _createBlock("div", _hoisted_18, [
                _createVNode("button", {
                  class: ["button-bulletin-change", {
              'button-bulletin-change-active': _ctx.isActive
            }],
                  onClick: _cache[9] || (_cache[9] = $event => (_ctx.oneLocationSAndAttribute()))
                }, _toDisplayString(_ctx.$t('statistics.OnYears')), 3)
              ]))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.oneLocalAndAttributeActive)
          ? (_openBlock(), _createBlock("div", _hoisted_19, [
              _createVNode("p", _hoisted_20, _toDisplayString(_ctx.$t('statistics.parameter')), 1),
              _createVNode("div", _hoisted_21, [
                _createVNode("input", {
                  type: "text",
                  class: "input input-parametrs",
                  onClick: _cache[10] || (_cache[10] = $event => (_ctx.changeCheckedActive = !_ctx.changeCheckedActive))
                }),
                _withDirectives(_createVNode("ul", _hoisted_22, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.checkedValues, (checkedValue) => {
                    return (_openBlock(), _createBlock("li", {
                      key: checkedValue.id,
                      onClick: $event => (_ctx.clickCheckedValue(checkedValue.id, checkedValue.name))
                    }, _toDisplayString(checkedValue.name), 9, ["onClick"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 512), [
                  [_vShow, _ctx.changeCheckedActive]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.oneLocalAndAttributeActive)
          ? (_openBlock(), _createBlock("div", _hoisted_23, [
              _createVNode("div", _hoisted_24, [
                _createVNode("p", _hoisted_25, _toDisplayString(_ctx.$t('statistics.parameter')), 1),
                _createVNode("input", {
                  type: "text",
                  class: "input input-parametrs",
                  onClick: _cache[11] || (_cache[11] = $event => (
              _ctx.attributechangeCheckedActive = !_ctx.attributechangeCheckedActive
            ))
                }),
                _withDirectives(_createVNode("ul", _hoisted_26, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.arrayData.attributes, (checkedValue) => {
                    return (_openBlock(), _createBlock("li", {
                      class: "auto-select-attribute",
                      key: checkedValue.id,
                      onClick: $event => (_ctx.selectAttributeBulletin(checkedValue.id))
                    }, _toDisplayString(checkedValue.name), 9, ["onClick"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 512), [
                  [_vShow, _ctx.attributechangeCheckedActive]
                ])
              ]),
              _createVNode("div", _hoisted_27, [
                _createVNode("p", _hoisted_28, _toDisplayString(_ctx.$t('statistics.selectLocation')), 1),
                _createVNode("input", {
                  type: "text",
                  class: "input input-parametrs",
                  onClick: _cache[12] || (_cache[12] = $event => (_ctx.LocationchangeCheckedActive = !_ctx.LocationchangeCheckedActive))
                }),
                _withDirectives(_createVNode("ul", _hoisted_29, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.arrayData.locations, (checkedValue) => {
                    return (_openBlock(), _createBlock("li", {
                      key: checkedValue.id,
                      onClick: $event => (_ctx.selectLocationBulletin(checkedValue.id))
                    }, _toDisplayString(checkedValue.name), 9, ["onClick"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 512), [
                  [_vShow, _ctx.LocationchangeCheckedActive]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_30, [
          _createVNode("div", _hoisted_31, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bulletinNameButton, (bulletin, index) => {
              return (_openBlock(), _createBlock("button", {
                key: index,
                class: "button-bulletin button-bulletin_name"
              }, [
                _createVNode("div", _hoisted_32, _toDisplayString(bulletin.name), 1),
                _createVNode(_component_svg_icon, {
                  name: "dagger",
                  onClick: _cache[13] || (_cache[13] = $event => (_ctx.deleteBulletin()))
                })
              ]))
            }), 128 /* KEYED_FRAGMENT */)),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bulletinAttributesMap, (bulletinAttribute) => {
              return (_openBlock(), _createBlock("button", {
                key: bulletinAttribute.id,
                class: "button-bulletin button-bulletin_attribute"
              }, [
                _createTextVNode(_toDisplayString(bulletinAttribute.name) + " ", 1 /* TEXT */),
                _createVNode(_component_svg_icon, {
                  name: "dagger",
                  onClick: $event => (_ctx.deleteAttributes(bulletinAttribute.id))
                }, null, 8, ["onClick"])
              ]))
            }), 128 /* KEYED_FRAGMENT */)),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bulletinLocationsMap, (bulletinLocation) => {
              return (_openBlock(), _createBlock("button", {
                key: bulletinLocation.id,
                class: "button-bulletin button-bulletin_location"
              }, [
                _createTextVNode(_toDisplayString(bulletinLocation.name) + " ", 1 /* TEXT */),
                _createVNode(_component_svg_icon, {
                  name: "dagger",
                  onClick: $event => (_ctx.deletelocations(bulletinLocation.id))
                }, null, 8, ["onClick"])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]),
        _createVNode("div", _hoisted_33, [
          _createVNode("div", _hoisted_34, [
            _createVNode("p", _hoisted_35, _toDisplayString(_ctx.$t('main.selectTypeDiagramm')), 1),
            _createVNode("p", {
              class: ["text", {
              'text-message': !_ctx.oneLocationAndAttributeIsActive
            }],
              style: {"font-size":"14px"}
            }, " * " + _toDisplayString(_ctx.$t('statistics.selectOption')), 3),
            _createVNode("div", _hoisted_36, [
              _createVNode("div", {
                class: "tabs__item tabs__item--active",
                onClick: _cache[14] || (_cache[14] = $event => (_ctx.setChart('line')))
              }, [
                _createVNode(_component_svg_icon, { name: "line-chart-activ" })
              ]),
              _createVNode("div", {
                class: ["tabs__item", {
                'no-click': _ctx.oneLocationAndAttributeIsActive
              }],
                onClick: _cache[15] || (_cache[15] = $event => (_ctx.setChart('bar')))
              }, [
                _createVNode(_component_svg_icon, {
                  name: "bar-chart-activ",
                  class: {
                  'grey-scale': _ctx.oneLocationAndAttributeIsActive
                }
                }, null, 8, ["class"])
              ], 2),
              _createVNode("div", {
                class: ["tabs__item tabs__item", {
                'no-click': _ctx.oneLocationAndAttributeIsActive
              }],
                onClick: _cache[16] || (_cache[16] = $event => (_ctx.setAmCharts('bar')))
              }, [
                _createVNode(_component_svg_icon, {
                  name: "multiaxis-chart-activ",
                  class: {
                  'grey-scale': _ctx.oneLocationAndAttributeIsActive
                }
                }, null, 8, ["class"])
              ], 2),
              _createVNode("div", {
                class: ["tabs__item", {
                'no-click': _ctx.oneLocationAndAttributeIsActive
              }],
                onClick: _cache[17] || (_cache[17] = $event => (_ctx.setChart('pie')))
              }, [
                _createVNode(_component_svg_icon, {
                  name: "pie-chart-activ",
                  class: {
                  'grey-scale': _ctx.oneLocationAndAttributeIsActive
                }
                }, null, 8, ["class"])
              ], 2),
              _createVNode("div", {
                class: ["tabs__item", {
                'no-click': _ctx.oneLocationAndAttributeIsActive
              }],
                onClick: _cache[18] || (_cache[18] = $event => (_ctx.setChart('doughnut')))
              }, [
                _createVNode(_component_svg_icon, {
                  name: "donught-chart-activ",
                  class: {
                  'grey-scale': _ctx.oneLocationAndAttributeIsActive
                }
                }, null, 8, ["class"])
              ], 2)
            ]),
            _createVNode("h2", _hoisted_37, _toDisplayString(_ctx.checkedBulletinName), 1),
            (_ctx.bulletinCategoryName)
              ? (_openBlock(), _createBlock("h4", _hoisted_38, " Категория : " + _toDisplayString(_ctx.bulletinCategoryName), 1))
              : _createCommentVNode("", true),
            _createVNode("h2", _hoisted_39, [
              _createVNode("button", {
                class: "button-using",
                onClick: _cache[19] || (_cache[19] = $event => (_ctx.downloadCanvas()))
              }, " скачать "),
              _createVNode("div", _hoisted_40, [
                (_ctx.isPredictionActive)
                  ? (_openBlock(), _createBlock("span", _hoisted_41))
                  : _createCommentVNode("", true)
              ])
            ]),
            (!_ctx.amchartIsActive)
              ? (_openBlock(), _createBlock("div", _hoisted_42, [
                  _hoisted_43,
                  _createVNode("div", _hoisted_44, [
                    _createVNode(_component_line_chart, {
                      type: _ctx.graphics.chart,
                      data: {
                  labels: _ctx.graphics.labels,
                  datasets: _ctx.dataValues
                },
                      options: {
                  responsive: true,
                  maintainAspectRatio: false,

                  scales: {
                    yAxes: [
                      {
                        ticks: { beginAtZero: true }
                      }
                    ]
                  }
                }
                    }, null, 8, ["type", "data"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.amchartIsActive)
              ? (_openBlock(), _createBlock("div", _hoisted_45, [
                  _hoisted_46,
                  _createVNode(_component_am_charts, { data: _ctx.amChartsData }, null, 8, ["data"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_47, [
          _createVNode("div", _hoisted_48, [
            _createVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('statistics.table')), 1),
            _createVNode("div", _hoisted_50, [
              _createVNode("div", _hoisted_51, [
                _createVNode("button", _hoisted_52, [
                  _createTextVNode(_toDisplayString(_ctx.$t('app.download')) + " ", 1 /* TEXT */),
                  _createVNode(_component_svg_icon, {
                    name: "triangle-down",
                    class: "button__icon"
                  }),
                  _createVNode("div", _hoisted_53, [
                    _createVNode("div", {
                      class: "expand__item",
                      onClick: _cache[20] || (_cache[20] = $event => (_ctx.downloadFileExel()))
                    }, [
                      _createVNode(_component_svg_icon, { name: "excel-file" }),
                      _hoisted_54
                    ]),
                    _createVNode("div", {
                      class: "expand__item",
                      onClick: _cache[21] || (_cache[21] = $event => (_ctx.downloadFilePDF()))
                    }, [
                      _createVNode(_component_svg_icon, { name: "pdf-file" }),
                      _hoisted_55
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_56, [
          _createVNode("div", _hoisted_57, [
            _createVNode("div", _hoisted_58, [
              _createVNode("table", _hoisted_59, [
                _createVNode("thead", null, [
                  _createVNode("tr", null, [
                    _createVNode("th", null, [
                      _withDirectives(_createVNode("input", {
                        type: "checkbox",
                        onChange: _cache[22] || (_cache[22] = $event => (_ctx.viewAllTable())),
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => (_ctx.inputSelect = $event))
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.inputSelect]
                      ]),
                      _hoisted_60
                    ]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bulletinAttributesMap, (bulletinAttribute) => {
                      return (_openBlock(), _createBlock("th", {
                        key: bulletinAttribute.id
                      }, _toDisplayString(bulletinAttribute.name), 1))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]),
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bullettinTable, (Table) => {
                    return (_openBlock(), _createBlock("tr", {
                      key: Table.id
                    }, [
                      _createVNode("th", null, _toDisplayString(Table.name), 1),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(Table.values, (lv) => {
                        return (_openBlock(), _createBlock("td", {
                          key: lv.id
                        }, _toDisplayString(lv.value), 1))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_main_footer),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withId(() => [
        (_ctx.changeactive1)
          ? (_openBlock(), _createBlock("div", _hoisted_61, [
              _createVNode("div", _hoisted_62, [
                _createVNode("span", {
                  class: "close",
                  onClick: _cache[24] || (_cache[24] = $event => (_ctx.changeactive1 = !_ctx.changeactive1))
                }, "×"),
                _createVNode("div", _hoisted_63, [
                  _createVNode("h2", _hoisted_64, [
                    _createTextVNode(_toDisplayString(_ctx.$t('message.authorized')) + " ", 1 /* TEXT */),
                    _createVNode("div", _hoisted_65, [
                      _createVNode("div", _hoisted_66, [
                        _createVNode("button", {
                          class: "button-using",
                          onClick: _cache[25] || (_cache[25] = $event => (_ctx.routerLink()))
                        }, _toDisplayString(_ctx.$t('profile.logIn')), 1),
                        _createVNode("button", {
                          onClick: _cache[26] || (_cache[26] = $event => (_ctx.changeactive1 = !_ctx.changeactive1)),
                          class: "button-create-new-report button-create-new-report__auth"
                        }, _toDisplayString(_ctx.$t('profile.cancel')), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64 /* STABLE_FRAGMENT */))
})